import type { IconProps } from './GearIcon'

export function MerelsMarkIcon({ width = 20, height = 20, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...props}
    >
      {/* square frame */}
      <path
        d="M15 15 V85 H85 V15 Z"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* three filled corner nodes */}
      <g fill="currentColor">
        <circle cx="15" cy="15" r="8" />
        <circle cx="15" cy="85" r="8" />
        <circle cx="85" cy="85" r="8" />
      </g>

      {/* large circle */}
      <circle cx="75" cy="25" r="22" stroke="currentColor" strokeWidth="8" fill="currentColor" />
    </svg>
  )
}
